const handleSubmitFail = () => (errors, _submitError, props) => {
  const keys = Object.keys(errors);
  if (keys.length) {
    const element = document.querySelector(`input[name="${keys[0]}"]`);
    if (element) {
      element.scrollIntoView(true);
      if (element.focus) {
        element.focus();
      }
    }
    if (props?.onSubmitFail) {
      props.onSubmitFail();
    }
  }
};

export default handleSubmitFail;
